import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import ProfileForm from '../components/DashboardComponents/ProfileForm';
import InnerBanner from '../components/PagesComponents/InnerBanner';
const Profile = () => {
 return (
    <>
    {/* <InnerBanner pageKey="profile" /> */}
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                     <ProfileForm/>
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default Profile;
